import { ImagePopup } from './image-popup/image-popup.component';
import { TextPopup } from './text-popup/text-popup.component';

export const Popups = () => {
    return (
        <div>
            <ImagePopup visible={false}></ImagePopup>
            <TextPopup visible={false}></TextPopup>
        </div>
    )
}